<script lang="ts">
  import Settings from '@athena-lib/Icons/Settings.svelte';
  import clsx from 'clsx';
  import { onClickOutside } from '@athena-lib/Fields/ProductWizardDropdown/onClickOutside.svelte';
  import type { CacheMeta } from '$lib/server/cache/cacheMeta';

  const { cacheMeta }: { cacheMeta: CacheMeta } = $props();
  let expanded = $state(false);
</script>

<div
  use:onClickOutside={() => {
    expanded = false;
  }}
  class={clsx('fixed bottom-0 right-0 z-[99] w-full', expanded && 'h-[50vh]')}
>
  <button
    type="button"
    class={clsx('pb-2 pl-2')}
    onclick={() => {
      expanded = !expanded;
    }}
  >
    <Settings
      sizeClass={clsx(
        !expanded ? 'bg-white text-black' : 'bg-black text-white',
        'p-1 h-12 w-12 rounded-full  ',
      )}
    />
  </button>
  {#if expanded}
    <div
      class="flex h-full flex-col gap-4 overflow-auto bg-st-black p-4 pb-8 font-mono text-st-white"
    >
      {#each cacheMeta.sort((a, b) => a.source.localeCompare(b.source)) as row}
        <div class="flex flex-row justify-between">
          <div class="flex gap-2 font-mono">
            <div><span class="bg rounded-sm bg-blue-300 p-2 py-1">{row.source}</span></div>
            {row.key}
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
